<template>
  <PlanBanner />
  <PlanWhy />
  <PlanPeak />
  <PlanContent />
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import PlanBanner from '@template/page/planStable/planBanner.vue';
import PlanWhy from '@template/page/planStable/planWhy.vue';
import PlanPeak from '@template/page/planStable/planPeak.vue';
import PlanContent from '@template/page/planStable/planContent.vue';

export default {
  name: 'plan',
  components: {
    PlanBanner,
    PlanWhy,
    PlanPeak,
    PlanContent
  },
  mounted(): void {
    $Store.Page().checkPointPlan($Enum.RouterEnum.PlanStable);
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/plan/';
</style>